import React, {useEffect, useState} from 'react';
import {Col, Row} from "react-bootstrap";
import {CalculatedOption, KoluSet} from "../../config/interfaces";
import {Brand} from "../../config/enums";
import RangeSlider from "react-bootstrap-range-slider";

interface OverviewProps {
    calculatedOptions: CalculatedOption[];
    chosenBrand: Brand;
    cheapest: CalculatedOption;
    sets: KoluSet[];
}

/**
 * A step in the stepper that gives an overview of the current situation of sets and a price estimate for electricity consumption.
 * @param {OverviewProps} props - The props that the Overview component accepts.
 * @param {CalculatedOption[]} props.calculatedOptions - Array of calculated options, every brand that is selected has one option in this array.
 * @param {Brand} props.chosenBrand - The selected brand in the TotalOverviewDialog that is selected as the current outcome.
 * @param {CalculatedOption} props.cheapest - The cheapest option from all calculated options. This changes every time a new calculation is executed.
 * @param {KoluSet[]} props.sets - The current sets of the selected calculated option.
 * @constructor
 */
const Overview = (props: OverviewProps) => {
    const {calculatedOptions, chosenBrand, cheapest, sets} = props;
    const [installatieKwh, setInstallatieKwh] = useState<number>(cheapest.sets.reduce((acc, curr) => acc + (curr.item ? curr.item.opp / 11 : 0), 0));
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [eindprijsPerKwh, setEindprijsPerKwh] = useState<number>(0.23);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [urenPerDag, setUrenPerDag] = useState<number>(8);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [factor, setFactor] = useState<number>(0.5);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [dagenPerJaar, setDagenPerJaar] = useState<number>(50);
    const [verbruikKwhPerJaar, setVerbruikKwhPerJaar] = useState<number>(0);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [kostprijsPerJaar, setKostprijsPerJaar] = useState<number>(0);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [kostprijsPerDag, setKostprijsPerDag] = useState<number>(0);

    useEffect(() => {
        setInstallatieKwh(calculatedOptions.filter(o => o.brand === chosenBrand)[0].sets.reduce((acc, curr) => acc + (curr.item ? curr.item!.opp / 11 : 0), 0));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [chosenBrand]);

    useEffect(() => {
        setVerbruikKwhPerJaar(Math.round(installatieKwh * urenPerDag * factor * dagenPerJaar * 100) / 100);
    }, [installatieKwh, urenPerDag, factor, dagenPerJaar]);

    useEffect(() => {
        setKostprijsPerJaar(Math.round(verbruikKwhPerJaar * eindprijsPerKwh * 100) / 100);
        setKostprijsPerDag(Math.round(verbruikKwhPerJaar * eindprijsPerKwh / dagenPerJaar * 100) / 100);
    }, [verbruikKwhPerJaar, eindprijsPerKwh, dagenPerJaar]);

    return <>
        <div className={'overview mt-5'}>
            <div>
                <Row>
                    <Col>
                        <h2>Overzicht</h2>
                    </Col>
                </Row>
                <Row>
                    <Col>Merk</Col>
                    <Col>{chosenBrand}</Col>
                </Row>
                <Row>
                    <Col># buitenunits</Col>
                    <Col>{sets.filter(s => s.item && s.rooms.length > 0).length} unit(s)</Col>
                </Row>
                <Row>
                    <Col># binnenunits</Col>
                    <Col>{sets.reduce((acc, curr) => acc + (curr.item ? curr.item!.aantalKamers : 0), 0)} unit(s)</Col>
                </Row>
                <Row>
                    <Col># kamers</Col>
                    <Col>{sets.reduce((acc, curr) => acc + curr.rooms.length, 0)} kamer(s)</Col>
                </Row>
                <Row>
                    <Col>Totaal vermogen</Col>
                    <Col>{Math.round(sets.reduce((acc, curr) => acc + (curr.item ? curr.item!.opp / 11 : 0), 0) * 100) / 100} kw</Col>
                </Row>
            </div>
            <div>
                <Row>
                    <Col>
                        <h2>Simulatie verbruik</h2>
                    </Col>
                </Row>
                <Row>
                    <Col>Prijs per kwh</Col>
                    <Col>&euro; {eindprijsPerKwh}</Col>
                </Row>
                <Row>
                    <RangeSlider size={'lg'} value={eindprijsPerKwh * 100} min={0} max={50} tooltipLabel={(value) => '€ ' + Math.round(value) / 100} onChange={(event) => {setEindprijsPerKwh(parseInt((event.target as HTMLInputElement).value) / 100);}} className={'custom-range'} />
                </Row>
{/*                <Row>
                    <Col>Uren per dag</Col>
                    <Col>{urenPerDag} uur</Col>
                </Row>*/}
{/*                <Row>
                    <Col>Factor</Col>
                    <Col>{factor * 100}%</Col>
                </Row>*/}
                <Row className={'mt-5'}>
                    <Col>Dagen per jaar</Col>
                    <Col>{dagenPerJaar} dagen</Col>
                </Row>
                <Row>
                    <RangeSlider size={'lg'} value={dagenPerJaar} min={10} max={150} onChange={(event) => {setDagenPerJaar(parseInt((event.target as HTMLInputElement).value));}} className={'custom-range'} />
                </Row>
{/*                <Row>
                    <Col>Verbruik in kwh per jaar</Col>
                    <Col>{verbruikKwhPerJaar} kwh</Col>
                </Row>*/}
                <Row className={'mt-5'}>
                    <Col>Prijs per jaar</Col>
                    <Col>&euro; {kostprijsPerJaar} (&euro; {kostprijsPerDag} / dag)</Col>
                </Row>
{/*                <Row className={'mt-5'}>
                    <Col>Prijs per dag</Col>
                    <Col>&euro; {kostprijsPerDag}</Col>
                </Row>*/}
            </div>
        </div>
    </>
}

export default Overview;